import { render, staticRenderFns } from "./CourseForm.vue?vue&type=template&id=1a479fce&scoped=true&"
import script from "./CourseForm.vue?vue&type=script&lang=js&"
export * from "./CourseForm.vue?vue&type=script&lang=js&"
import style0 from "./CourseForm.vue?vue&type=style&index=0&id=1a479fce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a479fce",
  null
  
)

export default component.exports